import MenuLink from "./MenuLink";

const LessonsLink = () => {
  return <MenuLink caption={"Lessons"} />;
};

export default LessonsLink;
